<template>
  <div class="xuanfu" v-if="Show_cebianlan" @click="drag">
    <div class="yincang" style=" cursor: pointer;" @click="UnShow">
      <p class="lianxi">
        收起
      </p>
    </div>
    <div class="weixin" style=" cursor: pointer;" @mouseover="showWx = true" @mouseout="showWx = false">
      <img src="./images/weixin.png" alt="" />
      <img src="./images/weixin-hover.png" alt="" />
      <p class="lianxi" style="width:30px">
        微信咨询
      </p>
      <div v-if="footerInfo.web_wx_account" v-show="showWx" class="telephone wxCode">
        <img :src="footerInfo.web_wx_account" class="wxImg">
        <div class="wxlabel">微信扫码，获取服务</div>
      </div>
    </div>

    <div class="weixin" style=" cursor: pointer;" @mouseover="showphone = true" @mouseout="showphone = false">
      <img src="./images/phoneNo.png" alt="" />
      <img src="./images/phoneActive.png" alt="" />
      <p class="lianxi" style="width:30px">
        电话咨询
      </p>
      <div class="telephone" v-show="showphone">{{web_contact_number}}</div>
    </div>

    <!-- <div class="weixin" style="margin-top: 10px; cursor: pointer;">
      <img src="./images/yijian.png" alt="" />
      <p class="lianxi">
        反馈
        <br />
        意见
      </p>
    </div> -->
    <div @click="toTop" id="btn" class="weixinyi" style="margin-top: 10px; cursor: pointer;">
      <img src="./images/huidingbu.png" alt="" style="width:25px;height:25px"/>
      <img src="./images/huidingbu-hover.png" alt="" style="width:25px;height:25px"/>
      <p class="lianxi" style="width:30px">
        返回顶部
      </p>
    </div>
  </div>

  <div id="mydiv" v-else>
    <div class="xianshi">
    <div class="yincang" style=" cursor: pointer;border:none " @click="Show_ceb">
      <p class="lianxi" style="color:#fff">
        展示侧边栏
      </p>
    </div>
  </div>
  </div>

</template>

<script>
    import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      gotop: false,
      timer: null,
      web_contact_number: '',
      showphone: false,
      showWx: false,
      Show_cebianlan:true,
      footerInfo:{}
    }
  },
  computed: {
            ...mapGetters({
                webInfo: 'getWebInfo'
            }),
  },
  created() {
    try {
      if (localStorage.getItem('webInfo')) {
        this.web_contact_number = JSON.parse(localStorage.getItem('webInfo')).web_contact_number
      }
    // eslint-disable-next-line no-empty
    } catch (error) {
      
    }
    this.footerInfo = this.webInfo
    console.log(this.footerInfo);
  },
  mounted() {
    // 此处true 需要加上 不加滚动事件可能绑定不成功
    window.addEventListener('scroll', this.handleScroll, true)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    drag(){
     
    },
    // 使 DIV 元素可拖动:
 dragElement(elmnt) {
     var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  if (document.getElementById(elmnt.id + "header")) {
    // 如果存在，标题是您从中移动 DIV 的位置:
    document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  } else {
    // 否则，从 DIV 内的任何位置移动 DIV:
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // 在启动时获取鼠标光标位置:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // 每当光标移动时调用一个函数:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // 计算新的光标位置:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // 设置元素的新位置:
    elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
    elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
    // 释放鼠标按钮时停止移动:
    document.onmouseup = null;
    document.onmousemove = null;
  }
},
    UnShow(){
      this.Show_cebianlan = false
    },
    Show_ceb(){
      this.Show_cebianlan = true
    },
    handleScroll() {
      let scrolltop = window.pageYOffset || document.documentElement.scrolltop || document.body.scrollTop
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false)
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      this.timer = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(this.timer)
        }
      }, 10)
    }
  }
}
</script>

<style scoped>
p {
  margin: 0 auto;
}
.xuanfu {
  position: fixed;
  z-index: 3;
  width: 60px;
  opacity: 1;
  background: #fff;
  border: 1px solid #e5e8eb;
  right: 30px;
  /* top: 40%; */
  bottom: 23%;
  cursor: move;
}
.xianshi{
  position: fixed;
  z-index: 3;
  width: 20px;
  height: 100px;
  opacity: 1;
  background: linear-gradient(132deg,#73aaff 2%, #0053ff 93%);
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  right: 10px;
  /* top: 40%; */
  bottom: 40%;
}
.yincang{
  height: 30px;
  border-bottom: 1px solid #e5e8eb;
  text-align: center;
  margin: 0 auto;
  margin-top: 8px;
}
.weixin {
  position: relative;
  height: 66px;
  width: 60px;
  border-bottom: 1px solid #e5e8eb;
  text-align: center;
  margin: 0 auto;
  margin-top: 15px;
}
.weixin img:nth-child(2){
  display: none;
}
.weixin:hover p{
  color: #1872ED;
}
.weixin img{
  display: block;
  margin: 0 auto;
}
.weixin:hover img{
  display: block;
  margin: 0 auto;
}
.weixin:hover>img:nth-child(1){
  display: none;
}
.weixin:hover img:nth-child(2){
  display: block;
}
.weixinyi {
  height: 66px;
  width: 60px;
  text-align: center;
  margin: 0 auto;
  margin-top: 15px;
}
.weixinyi img{
  display: block;
  margin: 0 auto;
}
.weixinyi:hover img{
  display: block;
  margin: 0 auto;
}
.weixinyi img:nth-child(2){
  display: none;
}
.weixinyi:hover p{
  color: #1872ED;
}
.weixinyi:hover img:nth-child(1){
  display: none;
}
.weixinyi:hover img:nth-child(2){
  display: block;
}
.lianxi {
  opacity: 1;
  width: 100%;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Medium;
  text-align: center;
  color: #51595e;
  font-weight: 600;
}
.lianxi:hover{
  color:#1872ed
}
.telephone {
  position: absolute;
  width: 160px;
  height: 45px;
  top: 5px;
  left: -175px;
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  line-height: 45px;
  text-align: center;
  background: #fff;
  color: #1872ed;
}
.telephone:after{
  width: 0px;
	height: 0px;
  content: "";
	border-top: 10px solid transparent;
	border-bottom: 10px solid transparent;
	border-left: 10px solid #fff;
	position: absolute;
	top: 10px;
	left: 160px;
}
.wxCode{
  height: 180px;
  top:-55px;
  padding-top: 24px;
  box-sizing: border-box;
}
.wxCode:after{
	top: 70px;
}
.wxlabel{
  color: #82858a;
  font-size: 12px;
}
.wxImg{
  width: 110px;
  height: 110px;
}
</style>
